import React from 'react';
import { Table } from 'semantic-ui-react';
import NoRows from '@/components/table/NoRows';
import selectors from '../hooks/selectors';
import DatasetSettingsTable from '../../settings/components/DatasetSettingsTable';
import DictionariesMetricsRows from './DictionariesMetricsRows';
import DictionariesMetricsHeaderRow from './DictionariesMetricsHeaderRow';
import RequestMetricsTableHeader from './RequestMetricsTableHeader';
import DatasetSettingsTableLoader from '../../settings/components/DatasetSettingsTableLoader';

const DictionariesMetricsTable = ({ category, code }) => {
  const { metrics, isLoading, noDictionaries } = selectors.useDictionariesMetricsTable({ category, code });

  return (
    <>
      {(isLoading) && (<DatasetSettingsTableLoader />)}
      {(!isLoading) && (
      <>
        <DatasetSettingsTable className="aridhia-dictionaries-metrics-table">
          <Table.Header>
            <RequestMetricsTableHeader numberOfColumns={5} />
            <DictionariesMetricsHeaderRow />
          </Table.Header>
          <Table.Body>
            {!noDictionaries && metrics && (<DictionariesMetricsRows dictionariesRequestMetrics={metrics} />)}
          </Table.Body>
        </DatasetSettingsTable>
        {noDictionaries && (<NoRows icon="table" entity="dictionary" className="min-h-35" />)}
      </>
      )}
    </>
  );
};

export default DictionariesMetricsTable;
